'use strict';
// @flow

export default class TextController {
  $state
  $scope
  $rootScope
  canvas

  /*@ngInject*/
  constructor($state, $scope, $rootScope, Canvas) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.canvas = Canvas;
  }

  $onInit = () => {
    this.$scope.$parent.isZIndexToolbarVisible = false;
    this.$scope.isToolboxVisible = false;
    this.$scope.currentItem = null;

    this.$scope.modelBinding = {
      text: '',
      font: 'Arial',
      color: '',
      size: 0,
      rotation: 0,
      borderWidth: 0,
      borderColor: '#ffffff'
    };

    this.$scope.availableFonts = [
      {
        name: 'Serifenlos',
        items: [
          { name: 'Arial', value: 'Arial' },
          { name: 'Arial Black', value: 'Arial Black' },
          { name: 'Comic Sans MS', value: 'Comic Sans MS' },
          { name: 'Impact', value: 'Impact' },
          { name: 'Tahoma', value: 'Tahoma' },
          { name: 'Trebuchet MS', value: 'Trebuchet MS' },
          { name: 'Verdana', value: 'Verdana' }
        ]
      },
      {
        name: 'Mit Serifen',
        items: [{ name: 'Georgia', value: 'Georgia' }, { name: 'Palatino Linotype', value: 'Palatino Linotype' }, { name: 'Times New Roman', value: 'Times New Roman' }]
      },
      {
        name: 'Verziert',
        items: [
          { name: 'Dancing Script', value: 'Dancing Script' },
          { name: 'Shadows Into Light', value: 'Shadows Into Light' },
          { name: 'Tangerine', value: 'Tangerine' },
          { name: 'Homemade Apple', value: 'Homemade Apple' }
        ]
      },
      {
        name: 'Block',
        items: [{ name: 'Courier New', value: 'Courier New' }]
      }
    ];

    this.canvas.events.addListener('canvas.onItemSelected', this.onCanvasItemSelected);
    this.canvas.events.addListener('canvas.onItemUnselected', this.onCanvasItemUnselected);
    const onArrange = this.$rootScope.$on('onArrange', this.onArrange);

    this.$scope.$on('$destroy', () => {
      this.canvas.events.removeListener('canvas.onItemSelected', this.onCanvasItemSelected);
      this.canvas.events.removeListener('canvas.onItemUnselected', this.onCanvasItemUnselected);
      onArrange();
    });
  }

  addTextBox = () => {
    this.canvas.addTextBox();
  }

  removeTextBox = () => {
    this.canvas.removeTextBox(this.$scope.currentItem);
  }

  onCanvasItemSelected = e => {
    let item = e.item;

    if(item.type != 'text') {
      this.$rootScope.$apply(() => {
        this.$scope.$parent.isZIndexToolbarVisible = false;
        this.$scope.isToolboxVisible = false;
      });
      return;
    }

    this.$rootScope.safeApply(() => {
      this.$scope.$parent.isZIndexToolbarVisible = true;
      this.$scope.isToolboxVisible = true;
      this.$scope.currentItem = item;

      this.$scope.modelBinding.text = item.text;
      this.$scope.modelBinding.size = item.fontSize;
      this.$scope.modelBinding.color = item.fontColor;
      this.$scope.modelBinding.rotation = item.rotation;
      this.$scope.modelBinding.borderWidth = item.borderWidth;
      this.$scope.modelBinding.borderColor = item.borderColor;
      this.$scope.modelBinding.shadowWidth = item.shadowWidth;
    });
  }

  onCanvasItemUnselected = e => {
    this.$rootScope.safeApply(() => {
      this.$scope.$parent.isZIndexToolbarVisible = false;
      this.$scope.isToolboxVisible = false;
      this.$scope.currentItem = null;
    });
  }

  onTextChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.text = this.$scope.modelBinding.text;
    this.canvas.renderStage();
  }

  onTextColorChanged = (hsb, hex, rgb) => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.fontColor = '#' + hex;
    this.canvas.renderStage();
  }

  onTextFontChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.font = this.$scope.modelBinding.font;
    this.canvas.renderStage();
  }

  onTextSizeChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.fontSize = this.$scope.modelBinding.size;
    this.canvas.renderStage();
  }

  onTextRotationChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.rotation = this.$scope.modelBinding.rotation;
    this.canvas.renderStage();
  }

  onTextBorderWidthChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.borderWidth = this.$scope.modelBinding.borderWidth;
    this.canvas.renderStage();
  }

  onTextBorderColorChanged = (hsb, hex, rgb) => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.borderColor = '#' + hex;
    this.canvas.renderStage();
  }

  onTextShadowWidthChanged = () => {
    if(!this.$scope.currentItem) return;

    this.$scope.currentItem.shadowWidth = this.$scope.modelBinding.shadowWidth;
    this.canvas.renderStage();
  }

  onArrange = (event, action) => {
    if(!this.$scope.currentItem) return;
    this.canvas.applyZIndex(this.$scope.currentItem, action);
  }
}



// WEBPACK FOOTER //
// ./client/app/configurator/text/text.controller.js